import { Provider } from 'react-redux';

import { QueryClientProvider, queryClient } from '@frontend/api';
import { theme, createStandaloneToast } from '@frontend/legacy-components';

import { stores } from 'store/configureStore';

import { UserGroupCollectionProvider } from 'utils/multisite/UserGroupCollectionProvider';

import NotificationToast from './components/subcomponents/NotificationToast';
import { NOTIFICATION_TYPES } from './data/constants';

const notificationFlash = ({ notification, thumbnailBlob }) => {
  const { toast } = createStandaloneToast({ theme });
  const duration = 10000;

  switch (notification.type) {
    case NOTIFICATION_TYPES.CHANNEL_EVENT:
    case NOTIFICATION_TYPES.CHANNEL_MENTION:
    case NOTIFICATION_TYPES.CHANNEL_REPLY:
    case NOTIFICATION_TYPES.CHAT_REPLY:
    case NOTIFICATION_TYPES.PARTBOT_REPLY:
    case NOTIFICATION_TYPES.SHARE_INVITE_FAILED:
    case NOTIFICATION_TYPES.SHARE_REINITIALIZATION_REQUEST:
    case NOTIFICATION_TYPES.TASKS:
    case NOTIFICATION_TYPES.THREAD_MENTION: {
      toast({
        position: 'top-end',
        render: ({ onClose }) => (
          <Provider store={stores.global}>
            <QueryClientProvider client={queryClient}>
              <UserGroupCollectionProvider>
                <NotificationToast
                  notification={notification}
                  isThumbnail={true}
                  thumbnailBlob={thumbnailBlob}
                  onClose={onClose}
                />
              </UserGroupCollectionProvider>
            </QueryClientProvider>
          </Provider>
        ),
        duration,
        isClosable: true,
        containerStyle: { zIndex: 'toast' },
      });
      break;
    }

    case NOTIFICATION_TYPES.ASSIGNED_TO_ACTION:
    case NOTIFICATION_TYPES.DIGIQUOTE_VIEW:
    case NOTIFICATION_TYPES.ESTIMATOR_ASSIGNMENT:
    case NOTIFICATION_TYPES.INTEGRATION_ACTION_FAILURE:
    case NOTIFICATION_TYPES.MANUAL_INPUT_COMPLETED:
    case NOTIFICATION_TYPES.NEW_QUOTE_FROM_EMAIL:
    case NOTIFICATION_TYPES.NEW_RFQ:
    case NOTIFICATION_TYPES.NEW_SUBQUOTE: {
      toast({
        position: 'top-end',
        render: ({ onClose }) => (
          <Provider store={stores.global}>
            <QueryClientProvider client={queryClient}>
              <UserGroupCollectionProvider>
                <NotificationToast
                  notification={notification}
                  isThumbnail={false}
                  onClose={onClose}
                />
              </UserGroupCollectionProvider>
            </QueryClientProvider>
          </Provider>
        ),
        duration,
        isClosable: true,
        containerStyle: { zIndex: 'toast' },
      });
      break;
    }
    default:
      console.error('Received notification of unknown type', notification);
      break;
  }
};

export default notificationFlash;
